import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { RoleDescriptor } from './model/role';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { IDataService } from '../common/IDataService';

@Injectable()
export class RoleService extends RESTServiceBase implements IDataService<RoleDescriptor> {

  public roleTypes = [{ 'id': 'Public', 'description': 'Adatszolgáltatói' }, { 'id': 'Administrative', 'description': 'Hivatali' }];

  constructor(
    authService: AuthService,
    conf: AppConfig
  ) {
    super(
      'v1',
      'RoleManagement',
      authService,
      conf.RMSConfig
    );

  }

  public create(role: RoleDescriptor): Promise<RoleDescriptor> {
    return super.post<RoleDescriptor>(
      new RoleDescriptor({
        id: undefined,
        href: undefined,
        alias: role.alias,
        description: role.description,
        systemRole: role.systemRole,
        roleType: role.roleType,
        modified: role.modified,
        deleted: role.deleted
      }));
  }

  public getRoles(view?: View): Promise<List<RoleDescriptor>> {
    return super.get<List<RoleDescriptor>>(undefined, view);
  }

  async GetList(v: View): Promise<List<RoleDescriptor>> {
    return await this.getRoles(v);
  }
  async GetById(id: string): Promise<RoleDescriptor> {
    return await this.getById(id);
  }
  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: RoleDescriptor): Promise<RoleDescriptor> {
    return super.put<RoleDescriptor>(id, role);
  }

  public getById(id: string): Promise<RoleDescriptor> {
    return super.get<RoleDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/role/role.service.ts